import { useI18n } from '@experience/i18n';
import type { TLocalesSupported } from '../types/i18n';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useComponentI18n<T extends Record<string, any>>(locales: Record<TLocalesSupported, T>) {
  const messages = {
    ru: locales.ru,
  };

  return useI18n({
    inheritLocale: true,
    messages,
  });
}
